import { CURRENT_BRAND_STORAGE_KEY } from "./activeBrandChrome";

/**
 * Resolve the selected-Brand context for Brand-scoped Support
 * (SUPPORT-QA-01). Precedence:
 *   1. BrandContext currentBrand (in-memory, authoritative once loaded)
 *   2. router location.state { brandId, brandName } (brand-shell navigation)
 *   3. persisted currentBrand (synchronous read — BrandProvider hydrates
 *      asynchronously, so a fresh mount must not bounce to the hub first)
 *
 * Returns { brandId, brandName } or null when no Brand is selected.
 * This is presentation context only — authorization is enforced server-side.
 */
export function resolveBrandSupportContext({
  currentBrand = null,
  locationState = null,
  storage = typeof localStorage !== "undefined" ? localStorage : null,
} = {}) {
  const fromContext = normalize(currentBrand?.id, currentBrand?.name);
  if (fromContext) return fromContext;

  const fromState = normalize(locationState?.brandId, locationState?.brandName);
  if (fromState) return fromState;

  if (storage) {
    try {
      const raw = storage.getItem(CURRENT_BRAND_STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        const fromStorage = normalize(parsed?.id, parsed?.name);
        if (fromStorage) return fromStorage;
      }
    } catch {
      /* ignore malformed storage */
    }
  }
  return null;
}

function normalize(id, name) {
  const brandId = String(id || "").trim();
  if (!brandId) return null;
  const brandName = String(name || "").trim() || brandId;
  return { brandId, brandName };
}
